import { StoreState } from '@/redux/types';
import { getConfigurationErrorsForView } from './getConfigurationErrorsForView';
import { getCurrentView } from './getCurrentView';

export function getConfigurationErrorsForCurrentView(state: StoreState) {
  const currentView = getCurrentView(state);
  return getConfigurationErrorsForView(state, currentView.id);
}
